import { API_URL, questionsLoader } from "./QuestionsLoader";
import { JSONAPIDocument } from "json-api-serializer";
import { PageQuery } from "./typings";
import { stringifyUrl } from "query-string";

export class TopicsApi {
    public static importTopics(data: JSONAPIDocument) {
        return questionsLoader.post({
            baseURL: API_URL,
            url: "/topics/import",
            data: data,
        });
    }

    public static getTopics(query: PageQuery = {}) {
        const url = stringifyUrl({ url: "/topics", query }, { arrayFormat: "comma" });
        return questionsLoader.get({
            baseURL: API_URL,
            url
        })
    }
}